// @ts-nocheck
import Card from './Card'
import './Card.scss'
export default Card
